
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'backspaceKey': `⟵`,
'clearKey': `⎚ Очистить`,
'deleteKey': `⌦ Удалить`,
'downKey': `↓ Вниз`,
'endKey': `⤓ Конец`,
'enterKey': `Заходите на`,
'escapeKey': `⎋ Побег`,
'f10Key': `F10`,
'f11Key': `F11`,
'f12Key': `F12`,
'f13Key': `F13`,
'f14Key': `F14`,
'f15Key': `F15`,
'f16Key': `F16`,
'f17Key': `F17`,
'f18Key': `F18`,
'f19Key': `F19`,
'f1Key': `F1`,
'f2Key': `F2`,
'f3Key': `F3`,
'f4Key': `F4`,
'f5Key': `F5`,
'f6Key': `F6`,
'f7Key': `F7`,
'f8Key': `F8`,
'f9Key': `F9`,
'h64cd12550420f6f1': html`Создать 
          <code>LICENSE 
          </code> файл 
        `,
'homeKey': `⤒ Дом`,
'keyCommand': `⌘ Командировка/победа`,
'keyControl': `^ Контроль`,
'keyOption': `⌥ Опция/Альт`,
'keyShift': `⇧ Смена`,
'leftKey': `← Левый`,
'pagedownKey': `▼ Pagedown`,
'pageupKey': `▲ Pageup`,
'rightKey': `→ Право`,
's00065e45db8c0441': `Дополнительные сведения см. в разделе Инструменты разработчика`,
's001dd78415a91fa0': `Желоб полосы прокрутки`,
's002fa7d1054ed082': `Пограничная рамка`,
's006f872a5b7f5279': `Sangro`,
's01b16a926920908b': `Казах`,
's01b56d233c6c5cac': `Секционирование`,
's01d32b35baa3b676': `Автор`,
's02106cc2ef0e7578': `Новая булавка...`,
's02ab1ea8e5100fc1': `Пометьте выбор как "двунаправленное переопределение".`,
's0312976fe9da5951': `Кнопка`,
's03608a32f05eded2': `Уменьшение масштаба`,
's036d35e03be98d22': `Математическая глубина`,
's037b1dc850a89273': `Альтернатива под`,
's0396202b716732ec': `Отметьте выделение как пройденное`,
's03f49e598ffb11cc': `Польша`,
's0448f1059fa01720': `Сохраняйте, делитесь или распечатывайте свои исследования. Редактируйте информацию, например название, язык или лицензию.`,
's0458872c43beadef': `Вставьте ряд перед`,
's04c939a414fdab21': `Тсонга`,
's050954cd4ae83304': `Интервал между словами`,
's05e9759cfd99c48f': `Оправдание`,
's063fa5a0a4903bf4': `Вбок, слева направо`,
's064339c229374050': `Кодирование`,
's06634274f19b0572': `Выбор контактов`,
's06743b24499f0035': `Якорный центр`,
's07808b0ca6da8fef': `Огороженный сайт`,
's07970793b21351fd': `Базовый контейнер Ruby`,
's079cf7850d9327f0': `Шрифт`,
's07aa10850d9ddcc7': `Форма`,
's07e6118e838b2e23': `Навигация`,
's0816468df86e4036': `Открывает настройки`,
's082869038c117fe5': `Португальский (Бразилия)`,
's086e6c267ade2609': `Насыщенность`,
's08e12ade32ef8125': `Setswana`,
's08e6bd98452e6bb9': `Аудио`,
's0978fb5ba3145996': `Вставка списка (неупорядоченного)`,
's09c3f1d21de14ae1': `Пометьте выделение как подчеркнутое`,
's0a2d91c6720033e9': `Отделка интервалов между текстами`,
's0a3ddcba94027d95': `Подгонка объекта`,
's0a6cb8d42cdb0c4a': `Эсперанто`,
's0a799f583098cadf': `Вставить навигацию`,
's0a7db790db1fc45c': `Пометить выделение как область`,
's0b1271f50a77dc73': `Коробка с содержимым`,
's0b24d08ea349b455': `Все, что вы можете вставить. Сначала идут неинтерактивные элементы, такие как списки или изображения, затем - интерактивные элементы, называемые виджетами. Вы можете получить новые, нажав на строку поиска.`,
's0bdca49248ba4820': `Ярлыки`,
's0befccf152b6c0a9': `Ориентируйтесь на метаданные`,
's0c11e479416c8421': `Вставьте надпись в таблицу`,
's0c27336067c59611': `Прокрутка прокладки`,
's0c4593d81f147042': `Базовый уровень`,
's0c4b2e98d4ab7f5a': `Команды приложения`,
's0c883713b83616a8': `Сохранить активный документ`,
's0ca5c0460199cba1': `Аббревиатура`,
's0cf10c4f40588f8d': `Подпись к таблице`,
's0d86afa3c6a1e28b': `Направление сгибания`,
's0dad143dff0079fc': `Малаялам`,
's0db05bd7ba6fff96': `Ваш исследуемый документ. Здесь можно писать текст, копировать/вставлять, редактировать и т. д.`,
's0dc452999c129e15': `Включить перезагрузку в реальном времени`,
's0de0febab8a4beaf': `Ошибка при чтении этого пакета`,
's0e44968489e076a8': `Китайский`,
's0e4862e87c7d53ce': `Пометить выделение как цитату`,
's0e6ea8870dbddab2': `Команды документа`,
's0ee28503778e4c0c': `Последний базовый уровень`,
's0ef01c03299bbb83': `Украшения`,
's0f17f32919661cff': `Монголия`,
's0f350bc4e538e3ea': `Слова`,
's105a06836c40fcb4': `Настройка фильтров, цвета и смешивания выбранных элементов`,
's106b274b5af798e5': `Приговоры`,
's1082e1649793dca9': `Пометить выбор как определенный термин`,
's10f3845975a0351e': `Редактирование метаданных`,
's1125d159f7e64df5': `Дисплей`,
's11326fd2590f4e5e': `По умолчанию`,
's1155ec07a221e739': `Полоса прокрутки`,
's1173bf7a3e0b74c9': `Минимум (у)`,
's1177237a3e0e548c': `Минимум (x)`,
's1219d97b49650c05': `Видимость`,
's123bea44f38abccf': `Вставить объект`,
's1245e2cb9f20197e': `Выровнять`,
's12946ec1b850962c': `Вставьте колонку после`,
's1351209ef74ee729': `Охватить все столбцы`,
's13c60cb409e8cb6f': `Выровнять по центру`,
's13ebd619c8a06a6d': `Автоматические строки сетки`,
's13ef8ca26ca8861b': `Разрезной элемент`,
's151bc2eea7a032a4': `-unchanged-`,
's153bc3c3aa39587b': `Голова стола`,
's156647179b21d351': `Вставьте тело таблицы`,
's158b6ec6b1fffcb2': `Перерыв после`,
's15d0c0657c1ee08c': `Ключ API`,
's1626a7e10a9f9dcc': `Устанавливает семейство шрифтов выделения`,
's1637c7d1a30629e2': `Пограничная коробка`,
's1641ab440bf4daa4': `Обновите этот пакет виджетов`,
's166bd56d19670a72': `Zoom`,
's1696c76a23c0834e': `Дополнительно: Показывайте пакеты с версиями 0.x.x в менеджере пакетов`,
's16b9446e3a70e1f4': `Атрибуты`,
's16f205466761e583': `Отсутствие оптического изменения размера шрифта`,
's16f2f1c2c516d307': `Откройте документ`,
's1749014f3f87fa6a': `Растяжка`,
's17597a8bb4810524': `Лицензия`,
's17bfaaa4e7528bc7': `Башкирия`,
's17fb3f4805f4f4b9': `Удалить поле`,
's181ef198cf83ec3a': `Бихари`,
's1857db526dc4dcdd': `Создать пакет`,
's18d5c44aae3dc82a': `Онлайн при редактировании`,
's1988d71ef8060edf': `Вставка строки таблицы`,
's19abee1277c9bca2': `Самоанский`,
's19daf2f26c19543d': `Конспект`,
's1a1acc902e6668e0': `Показать расширенное форматирование текста`,
's1a5230a71d9285c1': `Захват`,
's1aa1cb63ad44bc6f': `Зазор между колоннами`,
's1af8b67d1c85c811': `Пространство между`,
's1b4a36fce2456660': `Семейство шрифтов`,
's1c246045629b0016': `Пометить выделение как удаление`,
's1c3fc313a9184670': `Публичная ссылка`,
's1c65f5004a07dcfa': `Шотландский гэльский`,
's1c690963f1e2df00': `Вид, характерный для конкретной платформы`,
's1ca22ce85e074da5': `Pragma`,
's1d10d2058d8ca8dd': `Хотите короткую экскурсию с гидом?`,
's1d19244f549ec535': `Образование`,
's1d5c7b28e8b50d6d': `Степень бакалавра.`,
's1db591f5a54dbfd3': `Коробка с содержимым`,
's1dbb9f50e16c92a3': `Радиус границы`,
's1dfb744260fb3a01': `Двунаправленная изоляция`,
's1e9c2c654732cc5f': `Белоруссия`,
's1eaccbf2d6af8ab5': `Информация`,
's1efbfc3937d565bd': `Фон`,
's1f2b49c1bca2035d': `Каталонский`,
's1f74bdf32b51a5fc': `Фоновое изображение`,
's1f7698c061c208c9': `Открыть`,
's1f8e59d0624842ff': `Каннада`,
's1feab14d837eadb0': `Гуарани`,
's20deffeecf2699fb': `Корсиканцы`,
's21d61916eb8d137d': `Корпус стола`,
's21d723a1dbcd89c8': `Яванский`,
's21f8a2eaf5a70749': `Вставьте этикетку`,
's2206c42e5b835e6e': `Пометить выбор как аббревиатуру`,
's22a2348c46a912a0': `Вставить раздел`,
's233ae776268cd44b': `Бизнес`,
's236ed7ba747099b0': `Вес шрифта`,
's2474e7fb1aec9f05': `Тест`,
's2492f5fb1b05b45e': `Текст`,
's24949d7adbb5a098': `Ящик для инструментов`,
's252a52330d32b900': `Метаданные`,
's2540844a4bc4d9ba': `Требовать указания авторства?`,
's255857544a9d5ec0': `Сброс`,
's255c77900f2b5e0f': `Цветовая гамма`,
's256ab831a48c941c': `Удаляет все форматирование текста из выделения`,
's2591806d7b222591': `Сброс изменений`,
's25e1a07e454c2c11': `Сетка`,
's262abbaf1d05f009': `Мягкий свет`,
's266935f2447fcd98': `Над левым`,
's268ecd1cef45a9a8': `Вы уверены?`,
's2692bc028fed91f1': `⇪ Caps Lock`,
's27056379e0acfdb0': `Облегчить`,
's27076e66c5d483ba': `Выравнивание по вертикали`,
's2712dc5641a33226': `Учетные записи реестра пакетов предназначены для разработчиков и позволяют
          настраивать один или несколько реестров`,
's27cc88818cc46ff6': `Стабильный`,
's281d957112b10f12': `Редактируйте HTML документа напрямую`,
's28b6246ce616a548': `Вставка группы столбцов таблицы`,
's29a1c26521879b9f': `Уменьшить масштаб`,
's29acfd2778e8c377': `Скрыть расширенное форматирование текста`,
's29b24c06315e9343': `Вставить вход`,
's29eb103449472e3b': `Вставка заголовка (уровень 3)`,
's29ee7434494a0dfe': `Вставка заголовка (уровень 2)`,
's29f21c34494d614d': `Вставка заголовка (уровень 1)`,
's29fbfc3449557f72': `Вставка заголовка (уровень 6)`,
's29ff743449588131': `Вставка заголовка (уровень 5)`,
's2a031834495bcdb4': `Вставка заголовка (уровень 4)`,
's2a75c946ef4dcab7': `Разное`,
's2b2ae20d26f78ac2': `Блок`,
's2b8f50c64be440f7': str`Выберите 
          ${0}... 
        `,
's2ba5f4d8f3bd7c57': `Заказать`,
's2bad2d24def4aa0b': `Перевод строки (язык CJK)`,
's2ceb11be2290bb1b': `Отмена`,
's2ced8e8fafb499f6': `Удалить элемент`,
's2d986d31f8d67357': `Вставьте набор полей`,
's2d995a37cf5e4995': `Вставить NoScript`,
's2de969afacdaa7a6': `Форма`,
's2df075aface0dab8': `Поделиться`,
's2e192b19ed15fcf6': `Страница`,
's2e39b99cf23606fa': `Установите расположение выбранных элементов`,
's2e4818861000b13f': `Макет`,
's2e66bf8b833858f3': `Уйгур`,
's2e969a451b4955d1': `Маратхи`,
's2eda5288a65bca1d': `Переполнение (y)`,
's2edd6688a65e21f0': `Переполнение (x)`,
's2f0bcdffc92a786b': `Поплавок правый`,
's2f2044f2431a32d5': `Направление`,
's2f4d4bfbc466d91f': `Албания`,
's2f8da2cb5f236588': `Имя вашего пакета. Должно быть скопировано, например, \`@org/pkg\`. `,
's30cce87854901922': `Дошкольное учреждение`,
's3124653c272f054c': `Цвет правила колонки`,
's314a4f7685c8e824': `Всегда`,
's31c06e226322f065': `Избегайте сирот`,
's323dcde72b850272': `Общественный доступ`,
's32911e52ee8ac745': `Вставьте слот`,
's337a1e9022a8d19f': `Таблица`,
's33c1450d2822bb0f': `Вставка подписи к рисунку`,
's33c18d5a4cbffa2a': `Ирландский`,
's33f85f24c0f5f008': `Сохранить`,
's342b0cabfa672822': `Помогите пользователю найти ваш виджет`,
's3437e0d9899e7ae1': `Отправка телеметрических данных об использовании WebWriter.`,
's344ea8f4939cdc98': `Цвет`,
's34dcda3b0f9d5a98': `Переключить url`,
's34f724979a124c50': `Устанавливает цвет фона выделенного текста`,
's355b21b89ce5d9c5': `Подробности`,
's35ae5f4e0fa2777b': `Пользовательское выравнивание`,
's35aeaff1425bca9e': `WebWriter не поддерживает носители типа `,
's35c3125c7750681e': `Блокнот`,
's3643189d1abbb7f4': `Код`,
's3649bacefe731bf6': `Переключить панель инструментов`,
's365280e16a8ea32d': `Копирование выделения`,
's366991b9c9287765': `Справа`,
's36a194e38d653a26': `Аннотация данных`,
's36b3cefdcb897f15': `Перспектива`,
's372fae706048ce41': `Чет-нечет`,
's377e24af9628c37e': `Упорядоченный список`,
's37a8c35f6581da5f': `Без якоря`,
's37fa3b9cd51c2dfd': `Устанавливает размер шрифта выделения`,
's380d17664bb69531': `Вставьте столбец перед`,
's3815184eb09f0dcf': `Курсор`,
's382a2aa3984474dd': `Создать`,
's38980f98cb07ceb8': `Сохраните активный документ как копию`,
's3914cb410fca44d4': `Импорт`,
's3a179f6db2972384': `Рубиновая позиция`,
's3a5ca02f282d247e': `Поделиться...`,
's3ae67088bbefba98': `Пакеты`,
's3b0ab4b52326316f': `Свет`,
's3bdad99768e11911': `Explorable`,
's3cb47df8290fa94c': `Вставить опцию`,
's3cf89cb47fdde7e9': `Ссылка`,
's3d09398e555ee5f9': `Дополнительные параметры`,
's3d249bb480032121': `Список`,
's3d3efd1e19bdcfb4': `Аннотация даты/времени`,
's3d6a732c792ccb9e': `Рубиновая аннотация`,
's3d93f9ea0c5a13fa': `Изображение`,
's3d9548e211b958ce': `Пропускать наложения`,
's3e092e9d1ee2c5bb': `Клипса`,
's3e78ddc9a48a608d': `Красотка`,
's3eb6d1e6e79ed7c4': `Документы не найдены`,
's3eca5a034978754b': `Удалить выбор`,
's3f06e9abb6ebcb79': `Персонажи`,
's3f1e7a3f2b283d3b': `Маржа`,
's3f299e83cbf52fba': `Чжуан`,
's3f43ef2eaa1ec486': `Гуджарати`,
's3f7e097a9b2e6181': `Вставить статью`,
's3fd83566dd643d10': `Вставьте легенду`,
's3fe72792941c18f9': `Текст внизу`,
's3ffcdc5db5e7d0c5': `Реверс`,
's40e3826b7f74a3b5': `Пан (справа)`,
's40f07d7859284a44': `Доминирующий базовый уровень`,
's4101ada154a1b958': `Средняя`,
's410c465a5993f82d': `Возможность разрыва строки`,
's41322d19c928c603': `ИКТ`,
's417b90913e05bc17': `Предварительный просмотр`,
's418f2020fe996832': `Подтвердите изменения`,
's41c724f0698148e9': `Пометить выделение как сочетание клавиш`,
's41f65a763f8e44ab': `Группа заголовков таблиц`,
's42721130228841b0': `Штрих-коробка`,
's429bd646f1cf8bc6': `Учетные записи Grammar LLM позволяют использовать API Grammar LLM для исправления грамматики в тексте.`,
's429dd933ba95549b': `Вставьте адрес`,
's42e470ef1d707a28': `Автоигра`,
's42ffdab1291fb3de': `Вставьте строку после`,
's430831017f3f0499': `Перекос (у)`,
's430bd5017f42511c': `Перекос (x)`,
's433ba70286202ceb': `Разбить все`,
's441b20a8a50e36b4': `Македония`,
's445b8acb9206db6e': `Отбросить и отменить`,
's446a924922651ea0': `Подчеркивание текста`,
's44cdba92713de38e': `Площадь сетки`,
's45518abd911471d0': `Хорватия`,
's456a8d744313852a': `Пространство вокруг`,
's4634541f5056a546': `Абхазия`,
's46d4abe6255cb9e1': `Переназначить ярлык`,
's4730c232e7209c40': `Подровняйте оба`,
's474f0eec369d02a4': `Образец вывода`,
's47a8f6dfb38b9701': `Телугу`,
's47e257ae643b5851': `Пометить выделение как аннотацию даты/времени`,
's47ebf3a8fb3b10c1': `Ориентация`,
's4802bb8eb52fbdeb': `Портал`,
's4802e47fe2e95134': `Вариант`,
's491d2919cd6ec3d9': `Hue`,
's497838412cb455f2': `Тень от текста`,
's4993444bfd3f3e5e': `Свернуть`,
's49ad24935b14e3df': `Кечуа`,
's49c560aecfeb8c29': `Маска`,
's49dd67aed00029ef': `Математика`,
's49e763aed00877a8': `Главная`,
's4a894f57eba1cf1e': `Сочетание клавиш`,
's4ac1ad6ecd6bd810': `Мис. изд.`,
's4ad6e9d3c2365c98': `Жесткий свет`,
's4b2c143acf931122': `Высота линии`,
's4b58c01e2578f5e4': `Легенда`,
's4bbff4e008690da1': `Избегайте страниц`,
's4c402ff5355fd310': `Двунаправленное управление`,
's4caed5b7a7e5d89b': `Английский язык`,
's4cb38675a21b2c98': `Неподдерживаемый тип свойства '\${desc.type}' (обработка как JSON)`,
's4cc8391f172c0cdf': `Прекратить экскурсию`,
's4d528b416ac8dee2': `Вставка группы заголовков`,
's4d546f6c87128d5b': `Космос превыше всего`,
's4dcb9315f6527f9c': `Запуск при перезагрузке`,
's4e191bdb4700a6e9': `Оверскролл (x)`,
's4e1c7fdb470386ac': `Прокрутка (y)`,
's4e2562fe3990e621': `Ошибка при подключении`,
's4e361bf8eef3759a': `Разрыв слова`,
's4ea0f21fc2a338a1': `Поднимайтесь`,
's4eace13b3ed74187': `Побочный комментарий`,
's4efee5b48a4593cb': `Петля`,
's4f26e7cb7c0a8318': `Векторный рисунок`,
's4fd2e638aabb0bb3': `WebWriter поддерживает встраивание различных источников. Просто вставьте ссылку на
          контент из:`,
's4fda04cbc245e18b': `Альфа`,
's4ffac3fb33a2ee9b': `Тайский`,
's5015a8fb33b98872': `Тонкий`,
's50489ffb1bde152e': `Вставка`,
's5068560b8d39663d': `Кликабельная карта`,
's517acbf1f96324f9': `Вес`,
's523eb9043213ff0d': `Курсив`,
's52777d434baeed9b': `Вставьте индикатор выполнения`,
's52af5d7ac34c2163': `Настольный ряд`,
's52e0bdc3ee304436': `Вставьте счетчик`,
's531056f039febd39': `Вставка выбора`,
's536695196d0b6dc3': `Фарерские`,
's542fcefa0bbaed86': `Открыть или закрыть панель инструментов (только на узких экранах, в противном случае панель инструментов всегда видна сбоку).`,
's5432ad3c84273229': `Рисунок`,
's543906d1db8b2283': `Редактировать `,
's543c237e8c895ce8': `Бислама`,
's545ee1f373f249cf': `Камбоджа`,
's54897f2764b0e4d0': `Установите этот пакет виджетов`,
's54cbfaf2a8da7818': `Пушту`,
's550839f3e4e205bb': `Отметьте выбор как очень важный`,
's55905c735052d295': `Тематический перерыв`,
's5590dbf7e425789d': `Этикетка`,
's5623aa2f83b05c76': `Тибетский`,
's564d1648b1ceee9f': `В настоящее время`,
's565cd5ffb0158c46': `Избегайте региона`,
's571a4f19e2f140c7': `Сковорода (x)`,
's571db319e2f4208a': `Пан (у)`,
's575e795c45e2d97e': `Вернуться`,
's5787c6d5b3b5541a': `Путь клипа`,
's579c69f419b6caef': `Гладкий`,
's587ac858dd80f6fa': `Подписной индекс`,
's58bec0ecd4f3ccd4': `Строгий`,
's59404f5593c32fdc': `Кернинг шрифта`,
's5941292bb77281ab': `Норвежский язык Bokmål`,
's599dcd2472c75c19': `Параграф`,
's59b20e8af32606ed': `Афар`,
's5a1a0898baf20675': `Пометить выделение аннотацией данных`,
's5a356677b61a6b7e': `Молдавский`,
's5b474b5c0ac0c7c4': `Группа столбцов таблицы`,
's5b517ac216f9ee62': `Боковые`,
's5b8cc9bb61ddce15': `Вставить абзац`,
's5bba2ac2e53bd1fd': `Киргизы`,
's5be80ad6b8301710': `Последовательное начало`,
's5c1ecf88259b79f9': `Презентация`,
's5c2a1a52c0389c30': `Инженерия`,
's5c63af7695445fcf': `Стиль текста`,
's5d18ca4c3111be6f': `Вставьте шапку таблицы`,
's5d87c1e588f48d90': `Практика`,
's5d929ff1619ac0c9': `Поиск`,
's5da52af9b083c29a': `Модель`,
's5dc77784260a7236': `авто`,
's5e27738a2e8eb763': `Войти`,
's5e2cba97c0d971bd': `Перезагрузка пакетов`,
's5e53415a6d5719ad': `Социальные науки`,
's5e6a7a0c30d2a270': `Пропустить наложения (авто)`,
's5e9e8e4d21bafedc': `Производство продуктов питания`,
's5ed03bb1f3a15949': `Изображение`,
's5f43af3669b1e098': `Источник`,
's5feaf7fd7ee567c8': `Разбитое слово`,
's600fd23c9ce971e8': `Печать активного документа`,
's602bbd28dae2c60f': `Самостоятельный старт`,
's60ff598dfcf2c773': `Под правом`,
's61053f0e3ebbd272': `нормальный`,
's613c6ff83883c04f': `Столбец таблицы`,
's6196153c4b0c1ea0': `Установите`,
's61c017f6d5c303af': `Фризский`,
's61ded17ca3f48c82': `Смещение подчеркивания`,
's61eacb19db252f5e': `URL`,
's621ad19d35ba7742': `Выбор копирования`,
's624e31cd4f1b89d4': `Плавная прокрутка`,
's626daf42b1ab7df7': `Выровнять по левому краю`,
's6280bf993915c57a': `Поле прокрутки`,
's62b857f5b6693742': `Инупиак`,
's63d894b1ddb06289': `Описание`,
's63dfc5b1c1c27849': `Идиш`,
's63e03c70f67ebf9c': `Контекст`,
's63e71d20d1eaca93': `Немецкий язык`,
's640bc7710d0143ce': `Повторное выполнение последнего отмененного изменения в активном документе`,
's64dc1fc7e3db45c9': `Создайте новый документ`,
's65ac276544ba33cd': `SVG-файл`,
's66765c420ee578e4': `Пространство равномерно`,
's669b18c6d2d9c95b': `Нет`,
's6747dbf4ad6063ba': `Самостоятельное завершение`,
's6787497df07fa97e': `Может прокручиваться над остановками`,
's67c2b60a506a09e4': `Второе изд.`,
's680bd4d926cd5a84': `Сохранить 3D`,
's6827930ef1aeaf99': `Базовый URL`,
's684a16f3c711394d': `Над правом`,
's687e27f036a71b32': `Изолят`,
's68b87d7b61052dc3': `Строка таблицы`,
's68e0e3a2bab7ce3e': `Избегайте`,
's690da6b432987c6f': `Автоматическое резервное копирование изменений в текущий документ. Изменения восстанавливаются при перезагрузке WebWriter.`,
's69311c4e25074fb3': `Средняя школа`,
's697400b541fbc3cd': `По ссылке`,
's6988ab5d47593a26': `У вас последняя версия WebWriter.`,
's69a49786a8009f43': `Найдите пакеты...`,
's69b12144dbb6544d': `Лаос`,
's69d88ef4b2618980': `Обложка`,
's69fbbdb8ad2a084a': `Затемнить`,
's6a31eff1ec4f71ad': `Скрыть лицо (3D)`,
's6ac62e1c8c66f3bb': `Компактный суперскрин.`,
's6b585ba37cdb8260': `Наследуйте`,
's6b61f8abf89586be': `Иврит`,
's6bd7a02fdf93e653': `Выравнивание содержания`,
's6cfc66b824ea05ba': `Хрустящие края`,
's6d02dc19e21eb49c': `Топ`,
's6d1df519e235a6cf': `Twi`,
's6d60d595cb5070da': `Вьетнамцы`,
's6d8b3b8047ed378d': `Режим наложения Mix`,
's6d8c02aee480af7a': `Меню`,
's6dadeaaee49d6d18': `Мета`,
's6dfb502188a8c7c2': `Вставить стиль`,
's6e288a119281f4c2': `Рендеринг текста`,
's6e4c20c6debcd5ca': `Оправдывать на заказ`,
's6f84199e62584905': `Предварительно отформатированный текст`,
's6fb3053e7244d326': `Другие поля`,
's70178e04a3b691b6': `Открыть настройки`,
's7031ca562378bde6': `Геометрическая точность`,
's7060970b5ed20a58': `Интерактивность`,
's7136449045eff28c': `Тамил`,
's71940c32987f675f': `WebWriter Cloud`,
's71a0549fd71219c9': `Показать нестабильные пакеты`,
's71dec51005acc1e4': `Плотность рядов`,
's72f2a02e2a5a4ee3': `СМИ`,
's730182ad28374cda': `Объект`,
's731678e227a20559': `Это устройство`,
's736904f276fbd441': `Естественные науки`,
's739544d0c858c633': str`Или опустите 
          ${0} сюда 
        `,
's73cb20c838e761e1': `Выбор разреза`,
's7417792bbe720149': `Redo`,
's741fae02b3dd24f3': `Пикселизированный`,
's743f778233e42a3f': `Вставить отступление`,
's744d993d03f29851': `Экран`,
's748c0074eff45884': `Манипуляции`,
's74aa0039a87141e2': `Эллипсис`,
's74b9781bacfcc87c': `Пенджаби`,
's74cd20a7aece9b91': `Заполните поле`,
's75109f5307578a61': `Добро пожаловать в WebWriter`,
's75a27f43413e02c5': `Французский`,
's75d83fc3f0cfab40': `Заголовок`,
's762e5704cc84089d': `Установка других параметров стиля выбранных элементов`,
's77318393dfdb0775': `Удалить ряд`,
's77e594ddcc10c774': `Разрешить коммерческое использование?`,
's782eac2b3e80323d': `Пометьте выделение как подчеркнутое`,
's782f286a79cca35d': `Относительно`,
's78673a3539cb1915': `Слева вверху`,
's78789724e789221c': `Размер`,
's789ff24c8f03f1a4': `Расстояние между буквами`,
's7995733bf97c01cc': `Сербохорватский язык`,
's7a99528e7b64635a': `Окцитанский язык`,
's7aaf0c06e69600f1': `Ошибка с `,
's7ae49e142487766c': `Общественный доступ`,
's7af555180b30a947': `Откройте инструменты разработчика`,
's7b4ba250601b8667': `Вставить шаблон`,
's7b560d8693ed8f42': `Прямой`,
's7b9994904c4f5b54': `Таджикистан`,
's7bdf0fd5b014d36c': `Сильная важность`,
's7beb1e77e82363eb': `Отменить последнее изменение в активном документе`,
's7c61118554a0ec36': `Максимум (x)`,
's7c95876637f6a9d7': `Фильтр`,
's7cb4e55c59663b1c': `Компания`,
's7cfe12cd14df9950': `Выйти`,
's7d27db3c9639c6dd': `Альтернатива`,
's7d8103f6f06f83d6': `Набивка`,
's7d864465dddbb50d': `Разрешить изменение размера`,
's7de0e28d6c309a4e': `Разрешить сенсорные действия`,
's7dea785045c3cc74': `Нажмите новую комбинацию клавиш...`,
's7e0b179d4d1414eb': `Введите ссылку`,
's7e6570f2f1ae320f': `Синтезировать шрифты`,
's7ecb1f29332293e5': `Базовая линия выравнивания`,
's7ed13ccddb1bf3c3': `Накладка`,
's7edbe0b213199995': `Бакалавриат`,
's7ede1c55e35ce9d6': `Моделирование`,
's7f09197a4814079b': `Установка параметров интерактивности для выбранных элементов`,
's7f326a142e856656': `Стиль`,
's7fcb35d23be1e643': `Набор полей`,
's80570196a9ce6d11': `Включить телеметрию`,
's806f84eb0ace116e': `Посмотрите, что вы выбрали, и измените это. Копируйте, вырезайте, вставляйте, прикрепляйте или вносите изменения в макет. Предлагает различные опции в зависимости от выбранной области, например, форматирование текста.`,
's80a42b81c52d4d8f': `Цвет каретки`,
's80b71fc6f43c5ce1': `Свободный`,
's812cbda653daaeba': `Эта функция пока не реализована`,
's81c3d8809658b951': `Кашмири`,
's81cf65c5a46dea08': `Киньярванда`,
's81ecf2d4386b8e84': `Продолжить`,
's8247d32213e35f24': `Вставьте главный`,
's82665b2ffabc9c0a': `Сайт`,
's828b1ecea8715884': `Сковорода (слева)`,
's833bd0422a7ef95d': `Размер вкладки`,
's83420ad7b6a14db5': `Toggle Dev Tools`,
's83c15613b6f6f3c8': `Только онлайн`,
's83cd32b685ccc9b7': `Контролирует`,
's83f26d02dd7aa681': `Видимый`,
's840fa49e8989c028': `Положение/форма`,
's844a76d1843ceb3c': `Сброс настроек по умолчанию`,
's84e4e8ae645b82ac': `Справа вверху (y)`,
's84e9c7f8785ca60b': `Вставить форму`,
's8517ae4da104b004': `Группа столбцов таблицы`,
's85186a61e0d55bac': `Видео`,
's851a7deea5984646': `Лицензия как Creative Commons OER?`,
's85f9aa6d3ea0e421': `Группа нижнего колонтитула таблицы`,
's864b0e6270e97246': `Отметить выделение как побочный комментарий`,
's8670e5ad3bf0dcf8': `Сохранить как`,
's8688d74dd3716d6e': `Сочетания клавиш для команд`,
's86ca34c5287a2f38': `Волоф`,
's86f820d8007d0de4': `Край формы`,
's87cefc710b3567fb': `Содержите`,
's88676f992b2965db': `Растягивание содержимого ячеек`,
's886897f2fd4edb99': `Скрытый`,
's886c5db2a5579873': `Концепция`,
's888c71e8fcb916d3': `Автосохранение`,
's88a62d29529948fb': `Вставить таблицу`,
's89950d86c8004d4b': `Пропускать без накладок`,
's89bca7498f20e041': `Фоновый клип`,
's8a28bad9290d4761': `Оромо`,
's8a29cb39a42f83f3': `Перерыв до`,
's8a4ff2bd9c13498c': `Запись`,
's8a6585c48ea104e9': `Скрыть пустые ячейки`,
's8a9eb438abac7c6a': `Ярлыки`,
's8b0432eecbd8b034': `Обновление`,
's8b7580c35e2aef87': `Слева вверху (y)`,
's8bc4affa761aa8a2': `Вставить изображение`,
's8c7f51cb067644c7': `Список данных`,
's8d342ecaa9e75b9b': `Отношения`,
's8d797888455f4147': `Места для отдыха`,
's8d83386457e91813': `Отмена/повтор изменений или предварительный просмотр с точки зрения ученика.`,
's8d8643013a7754d1': `Выравнивание текста`,
's8df30fe2a50d3479': `Вставьте возможность переноса строки`,
's8e715248c3a78446': `Вырезать выделение`,
's8f29e48d6b9a1aa8': `Вставьте строку заголовка таблицы`,
's8f4be9f086eb530f': `Отменить`,
's8f533296a536965e': `Сохранить как...`,
's8fad58c831ecf017': `Текстовый контейнер Ruby`,
's8ffe7abcbed8eb43': `Вертикально, слева направо`,
's90105521fcc40453': `Учетные записи WebWriter Cloud позволяют хранить документы в Интернете и делиться
          ими с учениками. Добавьте учетную запись здесь, и она будет доступна для сохранения,
          загрузки, обмена и открытия документов.`,
's9095f01a80a91594': `Супер`,
's90f0fbc12e1e2b2f': `Палитра шрифтов`,
's90f7c1cf501ea0a7': `Цветной финт`,
's91093e0b087911ba': `Подчеркнутое положение`,
's919e1724f589c9b1': `Слот`,
's91c5ed7769d00b65': `Вставить вставку`,
's9219acd5bef6269e': `Под левым`,
's92548405912d46bf': `Выравнивание прокрутки с привязкой (y)`,
's9258280591309342': `Выравнивание прокрутки с привязкой (x)`,
's927d796559f49439': `Происхождение фона`,
's92b177e579ef7b97': `Акцент`,
's92f846b9be2e8e8d': `Пометить выделение курсивом`,
's93566b84230af4f5': `Вставить картинку`,
's936aa0b239679585': `Вставьте тематический разрыв (обычно отображается в виде горизонтальной линии).`,
's9370dc6afa716b57': `Граница`,
's93f083e654a45715': `Бретон`,
's94653c76b2d86a04': `Определенный срок`,
's9485af2e7cd9418f': `Начальная школа`,
's94d2eee44b292567': `Переключение дополнительных опций`,
's94d61907ee22a8c1': `Корейский`,
's94eb1effbbb6498b': `Перелив`,
's951aa3a6439f1271': `Маркер списка`,
's9565553d163fc92a': `Скрипт`,
's957787fc6b7ea5c0': `Сковорода (вверх)`,
's95d56e58f816d211': `Голландия`,
's95d8e41a64635c7c': `Белое пространство`,
's95de7e1eff6c053e': `Горизонтально, сверху вниз`,
's960d3a90ac199368': `Раэто-румынский язык`,
's96532132a29dd542': `Вставить звук`,
's96a045dcade75ad0': `Колонна плотная`,
's9781a5bb3fcb26a3': `Сначала выберите компанию`,
's978522fbc9577a7e': `Сомали`,
's97881699a2b21d5b': `Зазор между рядами`,
's97aa76056a81bd36': `Метрики`,
's986facb3ecc9602c': `Вбок, вправо-влево`,
's987abd19fac8cf55': `Sub`,
's9896529e5cb20558': `Внешний файл`,
's98977a87d1b93941': `Сброс информации, стилей и скриптов`,
's990d0e0fa2ab00b5': `Галисийский`,
's99229574e5692f19': `Гренландия`,
's99a990f3841ad283': `Файлы `,
's99b38e000175cc84': `Зачеркивание`,
's99f110d27e30b289': `Название`,
's9ab10fbf4c7a7322': `Положение подчеркивания`,
's9abadcc828884d7b': `Textarea`,
's9b7cd8860c8fc922': str`
          ${0}
          будет перезаписана. Вы уверены? 
        `,
's9c11f2d9335d8bd1': `Ория`,
's9c356016f81585f6': `Цвет фона`,
's9ca757effd747da9': `Урду`,
's9caf10388ab3562f': `Столбец стола`,
's9cf68f87b8e6122f': `Азербайджан`,
's9d167ef77aed79b6': `Слой`,
's9d2d00982edafabb': `Турецкая`,
's9d430adc5be110e9': `Обратный ряд`,
's9d54829be67943d3': `Интерлингва`,
's9d54869be6794a9f': `Интерлингва`,
's9d668a34af4128ff': `Удаление`,
's9df571714a1efb44': `Доступна автосохраненная версия этого эксплорера. Загрузить ее?`,
's9e28faa598332e2b': `Вставить видео`,
's9e3dbb678150edd4': `Установите семейство шрифтов`,
's9e40e59654c8ad67': `Колонка`,
's9e85800d3700e31c': `Трек`,
's9e8d3665edde89a6': `Науру`,
's9eefe6e57e4e1661': `Вариант шрифта`,
's9f1ecdb3061d9cbc': `Сохраняйте пространства`,
's9faf26107ed49fb9': `Вставка ячейки таблицы`,
's9fbe26cfd7845469': `Хауса`,
's9fc686f7bbd941e2': `Переход`,
's9ff3121d30f88d52': `Нормальный`,
's9ffe1bbe64712bf1': `Холст`,
'sa00df4e39c72d3b4': str`
          ${0} не поддерживается 
        `,
'sa013e119fec906fb': `Ряд`,
'sa01e7bf33563ef72': `Справочное приложение`,
'sa126cf8c627cec1e': `Рендеринг изображений`,
'sa13f72278add7513': `Под правом`,
'sa1647e3b36ec08d7': `Соедините вертикально`,
'sa172190ea21f9b1c': `Зайдите в настройки, откройте исследуемый объект или создайте новый.`,
'sa1c6c459b9b5115c': `Абсолют`,
'sa2cba871f6cdd99f': `Ассамцы`,
'sa2eff4dad1c119f1': `Шаблон сетки`,
'sa30c12014e955946': `Русский`,
'sa30f1981fd1cd441': `Размер шрифта`,
'sa311a24c1471a974': `Документ`,
'sa352d168b262aa06': `Вставьте нижний колонтитул`,
'sa37fee6a52d18063': `Удалить документ`,
'sa39c7ac1d37f3bce': `Пометьте выделение как "двунаправленную изоляцию".`,
'sa3b4c01623211544': `Force`,
'sa40fd43756fa8913': `Персидский`,
'sa417644bef21a9aa': `Безымянная тема`,
'sa43800e28be1bdbc': `Цвет украшения`,
'sa477cb1825dceb3b': `Судан`,
'sa492a51a707930fa': `Вставка блочной цитаты`,
'sa4e5b39489ecf31a': `Xhosa`,
'sa4f137f8619093a5': `Надпись внизу`,
'sa50d3c35533f1d99': `Все поля`,
'sa53c5cb03a8fda50': `Закрепите выделение в виде фрагмента на палитре`,
'sa557ae6bee9148a6': `Прогресс`,
'sa589e1df65dde0ec': `Установите размер, отступы и поля выбранных элементов`,
'sa5c371b4bb75e590': `Слева`,
'sa5c80e623459ffe4': `Вставьте заголовок`,
'sa5df1bcdba46c3fb': `Рисунок Подпись`,
'sa602e3fd3f2d98fd': `Анимация`,
'sa644d580d8a11e60': `Выравнивание рубина`,
'sa645d315510dc09e': `Выберите путь с диска`,
'sa65d4ad99f1d8c06': `Установите фон текста`,
'sa6607436f60ccc1a': `Эстония`,
'sa6f8d27bca557059': `Переместите элементы мета/ссылки/стиля вверх/вниз в этот элемент`,
'sa757645ad842da97': `Сохраняйте перерывы`,
'sa75b95980cd80e78': `Редактор`,
'sa7698b3d20a6d1ec': `Прокрутка`,
'sa778acc33947c7b8': `Завершить экскурсию`,
'sa78a67272a4a6f95': `Математическая формула`,
'sa79167651dce1e80': `Альтернативный текст`,
'sa7af797a46c7d09a': `Нижний колонтитул таблицы`,
'sa7dbe35b758c138d': `Вставьте холст`,
'sa7dc6b8ef3f595dc': `Вставить источник`,
'sa8279f8211b3950d': `Сохраняйте разрывы и пространства`,
'sa8b55cab62e439b5': `Удалить колонку`,
'sa8bbe0197d31b423': `Краткое описание`,
'sa9ff3b762365abe6': `Начало преобразования (z)`,
'saa02e3762368ff35': `Начало преобразования (y)`,
'saa065776236bfa28': `Начало преобразования (x)`,
'saa33768e03c45fc8': `Размер файла`,
'saaad98061a20ac39': `Вставьте математическую формулу`,
'saab875d8cfcfe712': `Тема`,
'saad4380b9cc6cefd': `Альтернатива`,
'saaec15c97a9e4245': `Реверс колонны`,
'sab0c57df694a0a09': `Начало обрезки`,
'sab4d9283896d9422': `Пиксели с разрешением привязки`,
'sab55faae8e165407': `Padding&lt;br&gt; как зазор`,
'sab5e7d2a069a2951': `Профессиональный сертификат.`,
'sab726d2db7e6b93d': `Кирунди`,
'sac687b8649989de8': `Выровнять вправо`,
'sac895c732f350ac5': `Темнота`,
'saced41ddda8b2354': `Гибкая основа`,
'sad190f86451081c0': `Непали`,
'sad6be321164d08c8': `Компактная математика`,
'sadd352cc7f6f2307': `В сторону`,
'sae098810f946ca7c': `Тагальский язык`,
'sae185e6af80ec81e': `Шведский`,
'sae1c7f13b7c0c47f': `Начало`,
'sae76e25497dcee58': `Recto`,
'sae9c790b88be7eb9': `Маори`,
'sae9d739068eee2c5': `Татар`,
'saf312eaeec77a802': `Вставьте список описаний (глоссарий, список терминов)`,
'saf3da7c95cb17260': `Пометить выделение надстрочным индексом`,
'saf440a0a592f2835': `Обновление до`,
'saf9e5134ba1a7d30': `Защелка для прокрутки`,
'safc6f203342d09e2': `Переключение предварительного просмотра для активного документа`,
'sb0a7e3adf4a125ee': `Справа вверху`,
'sb0a974028c99ca6d': `Разрешить адаптацию?`,
'sb0d4f0f7993cf085': `Установите размер шрифта`,
'sb0f3327210fe18fc': `Колонны`,
'sb0f93c1c60c0249a': `Рубиновая основа`,
'sb1494c08c8c720d1': `Установите цвет текста`,
'sb19611adbc88f711': `Дополнительно: Показывайте команды редактирования исходного текста, например, для отображения HTML-файла документа или добавления пользовательских стилей и скриптов.`,
'sb206d700d26b14ff': `Подчеркните`,
'sb233557012dcb328': `Двигайтесь вниз`,
'sb26035b596566abf': `Безымянный`,
'sb2cda80610c8d6ea': `Пространство все`,
'sb2dc787b0983ebc6': `Литва`,
'sb31cdff08b1c5a50': `Синдхи`,
'sb38d497d992ab4a4': `Центр`,
'sb3ba3276ae93627c': `Вставка предварительно отформатированного текстового блока`,
'sb430f5b4824de0d3': `Выберите макет`,
'sb43db07b24da018a': `Амхарский язык`,
'sb45f9fb4dba6e71a': `Не установленный`,
'sb4e003a459464d85': `Курдский`,
'sb4f0310e6787d098': `Узбек`,
'sb4f1dffbb6be6302': `Очистить`,
'sb51270e19988f9bd': `Регион`,
'sb59d621e3c93cc27': `Общие границы ячеек`,
'sb5e9e1776242b028': `Взаимодействие`,
'sb60bc1250aad44c1': `Пролет`,
'sb60dd9d23d31ee66': `Докторская степень`,
'sb6103872073d369e': `Вставить детали`,
'sb616811735bfbafd': `Ячейка стола`,
'sb628960829e223bb': `Пропустить все наложения`,
'sb6434faf698b02a2': `Шона`,
'sb657bfe93338dc8b': `Волапук`,
'sb66beca1e766dcb3': `Применять и импортировать`,
'sb66e2181a7b5738a': `Включая телеметрию, вы разрешаете сбор и хранение данных в соответствии с нашими`,
'sb67e0e7c0869f982': `Разница`,
'sb68e83cda6c85af8': `Заголовок таблицы`,
'sb6b268120592dc53': `Хинди`,
'sb6ca0a8bb3caae69': `Толщина декорирования`,
'sb70c17f7899f9b01': `Латинская`,
'sb71941f552f3504d': `Установите специальное значение`,
'sb740eab4afd5a710': `Автоматический поток по сетке`,
'sb741b6e0ca589122': `Обратный слой`,
'sb7c77d0415de05cf': `Выполните тесты`,
'sb7fb7568f6883ab8': `Поделиться активным документом`,
'sb85774dc5d18ff0f': `Подтвердите`,
'sb85b1e36579852a6': `Неверный адрес электронной почты или пароль`,
'sb884fa76bfc55429': `Арабский язык`,
'sb8a3d4df7d1c5e6b': `Баланс`,
'sb8f610a0e8df91fc': `Luminosity`,
'sb8f855b49234b81b': `Применить`,
'sb905da066c10182c': `Плюс более темный`,
'sb940ade1bd81be7e': `Под левым`,
'sb9e9a7dd45966756': `Пометьте выделение жирным шрифтом`,
'sba509fd8ed61d1d5': `Несохраненный файл`,
'sba64d8954d027206': `Непрозрачность`,
'sba88d90cd6c751b3': `Правило колонны`,
'sbaf0a7c417e388af': `Здоровье`,
'sbb15d427ee1aa676': `Тигринья`,
'sbb34f2e3aa40af4e': `Тонга`,
'sbb55f9f2d69fd327': `Фоновый фильтр`,
'sbb85a407d730e13d': `Вставить поиск`,
'sbb86c6c96f598bb8': `Смешанные`,
'sbba0156f795d8c07': `Редактирование выбора`,
'sbba865d4b437944f': `Атрибут`,
'sbbe639e3a3ed95d1': `NoScript`,
'sbc5bb5bb74d141b9': `Удалить`,
'sbc5f2a81604baf9b': `Заголовок 6`,
'sbc5f2b81604bb14e': `Заголовок 5`,
'sbc5f2c81604bb301': `Заголовок 4`,
'sbc5f2d81604bb4b4': `Заголовок 3`,
'sbc5f2e81604bb667': `Заголовок 2`,
'sbc6953a36ced943f': `политика конфиденциальности`,
'sbd181cd54b8402a4': `Редактирование выбора`,
'sbd35ee879d9cf770': `Рубиновый текст`,
'sbd40f40cbadd38d5': `Удалите этот пакет виджетов`,
'sbd72dc858de95ce8': `Бирманский`,
'sbe3c60c65f129daa': `Гуманитарные науки`,
'sbe4a7c8f231739b3': `или вставить/вставить/выбрать файл`,
'sbe90de083557ef3e': `Суахили`,
'sbefb6064cba01844': `Вставьте разрыв строки`,
'sbf00e1ee999ea94e': `Вставить сценарий`,
'sbf519920c2017d67': `Подвесной`,
'sbfa01f189a68d3e9': `Гибкий рост`,
'sbff54e740c4086eb': `Показать неизвестные пакеты`,
'sbfff51feacf30196': `Санскрит`,
'sc0ceaa9843510f67': `Туркмен`,
'sc1611c0558728a2a': `Позиция`,
'sc1a155cc25899250': `Группа строк таблицы`,
'sc1aa1f6051b7102a': `Румыния`,
'sc1edebeaef92b7bd': `Исправленный макет таблицы`,
'sc1fff4f356dfb2fb': `Преобразование`,
'sc24bda3c061fddf8': `Кликабельная область`,
'sc252a4e091763606': `Вставка нижнего колонтитула таблицы`,
'sc2536e077514accc': `Прокрутка`,
'sc275dd00036d16cb': `Характер в кавычках`,
'sc28864200d2a3799': `Скопируйте QR-код в виде изображения`,
'sc2a24a9dd41a9503': `Линия декорирования`,
'sc2b734cca2fa643b': `Панорамирование (вниз)`,
'sc2e2a0dbf03723b7': `Дополнительно: Показывать пакеты из неизвестных источников в менеджере пакетов (Предупреждение: может быть небезопасно)`,
'sc3998b77d72c2932': `Вставка веб-сайта (в виде встроенного фрейма)`,
'sc3ac225273c8316b': `Общие сведения`,
'sc3cfee84dbbf36ae': `Локальный файл`,
'sc3f09a9b6fa4fbed': `Внутри`,
'sc43767deea72e9f3': `Список описаний`,
'sc462bbdd36bcba6b': `Справочный ящик`,
'sc4ee3e4ee994dafd': `Украина`,
'sc50d09edf9325339': `Диалог`,
'sc52b67794c06a0d3': `Начало перспективы (y)`,
'sc52e8b794c0913d6': `Начало перспективы (x)`,
'sc53de149fcaad713': `Межсимвольный`,
'sc546f489f9c0cced': `Переключение режима тестирования для активного документа`,
'sc5bcf50d1b578d9f': `Настройки функций шрифта`,
'sc5cb39478b9b7625': `Пометить выделение как подписку`,
'sc6415b50ff928294': `Элемент списка`,
'sc650ff15b20fe9d3': `Поворот (z)`,
'sc6578b15b2154365': `Поворот (x)`,
'sc65aff15b2183e58': `Поворот (y)`,
'sc6da0f4a7e4d710e': `Переопределение языка шрифта`,
'sc74e3567875ce255': `Как тег вашего виджета, так и имя вашего пакета NPM`,
'sc7eb080b96e244df': `Малайцы`,
'sc8ac7ef92b95df3f': `Перемещение (x)`,
'sc8af536e2084ade0': `Палитра`,
'sc8b022f92b992bc2': `Перемещение (у)`,
'sc8b39af92b9c2d81': `Перемещение (z)`,
'sc8d2c7f6c33a2b32': `Установка стиля текста (выравнивание, отступ, интервал и т. д.) для выбранных
          элементов`,
'sc8fa0e3de389ef1c': `Настройка размера шрифта`,
'sc9474bf7a0668d73': `Резюме`,
'sc94e314312a8900c': `Чехия`,
'sc980855a000b76ea': `Дно`,
'sc98b103772de63f4': `Финский`,
'sca7cfe2bef51b2a5': `Корень`,
'sca7fed2bef53cb99': `Роль`,
'scabe6ecee5e01fd2': `Мальтийский`,
'scace301a88231cce': `Встроить`,
'scbc55f622ec078c1': `Шкатулка для просмотра`,
'scbe537fc38ff4c13': `Автоколонки сетки`,
'scc1db59d292cbc4c': `Раздел`,
'scc56b218a2689c42': `Армянский`,
'scc5ba32e0de06744': `Сесото`,
'scd15088c39fe9edf': `Коробка с прокладками`,
'scd9cedeb5ece3adb': `Дефис`,
'scdf536b65be39ec5': ` Создание/импорт`,
'sce8a4e3f7c98482d': `Сисвати`,
'scec2be75ee985f6c': `Идеографический`,
'sceecdd0bb404bc17': `Вставка группы опций`,
'scf00d48fd5953a03': `Греция`,
'scf932840a69dbb7c': `Португальский`,
'scf932a8577057752': `Нижний колонтитул`,
'scf95dcb12a950a5c': `Аймара`,
'scfcb70f2a15eaf14': `Справа внизу`,
'sd01178c54f648118': `Балансовые колонки`,
'sd03bff50f87f82d4': `Дефисный символ`,
'sd05a155fe09c2866': `Онлайн при использовании`,
'sd0864ea6cb6ef22e': `Сообщество`,
'sd10fdbe6caf9a998': `Разрыв строки`,
'sd121d3b959b7888d': `Оптимизируйте скорость`,
'sd1a78e667a1a139f': `Пометить выделение как вставку`,
'sd1cffad290ea5b3b': `Сохраняйте все`,
'sd1f10284eeb17b25': `Фиджи`,
'sd1f44f1a8bc20e67': `Электронная почта`,
'sd1f81984eeb7c0e8': `Наполнение`,
'sd29dc07235eea0f5': `Котировка`,
'sd2addf69477cd4b4': `Импортный пакет`,
'sd2ed26defc646d47': `Фильтр для заднего плана`,
'sd2ef82b8ea877c6d': `Африканцы`,
'sd319aae1401f1e19': `Исправлено`,
'sd3a288c1094b8a63': `Ширина правила колонки`,
'sd3c65ef5c380c046': `Вставка`,
'sd3dcb76f7b28adb8': `Латвия`,
'sd3eca1e0f4209f6e': `Подровняйте все`,
'sd3f402df8619ddcd': `Эта информация о вас автоматически добавляется в новые документы. Вы можете изменить
          это для каждого документа в редакторе метаданных.`,
'sd4368b12645d3c0f': `Вставить портал`,
'sd452cebf4a0313d1': `Показать команды редактирования источника`,
'sd48cc52117f4d68b': `Итальянский`,
'sd52660ee947ca58b': `Вставка столбца таблицы`,
'sd588d17a1b25c220': `Переполнение текста`,
'sd5be6f6d85fc0c9b': `Zulu`,
'sd5bf67958b08b4cf': `Высшее образование.`,
'sd5cf95145e4d89ca': `Открепить этот фрагмент`,
'sd5fd9d11a92f5b1d': `Слева внизу (y)`,
'sd60c9bbc51375635': `Вставить кнопку`,
'sd66c4767fa3dde28': `Акцентный цвет`,
'sd679c8b1bf8cc8a5': `Малые кепки`,
'sd7086c4425c53c80': `Семейство шрифтов`,
'sd837f42ac7cbfb58': `Форма (снаружи)`,
'sd88076d2994ee0fb': `Исключение`,
'sd89a2e529b31ef43': `Реверс`,
'sd8a345e95668b73b': `Вертикально, справа налево`,
'sd8ce9e57270b030d': `Растягивание шрифта`,
'sd8ecf227c7c49331': `Математические`,
'sd8f923198e0c5c6a': `Конец`,
'sd9c21e5f60d6bdd8': `Датский`,
'sd9ff8e2612e63d50': `Размер пограничного поля`,
'sda2d76b976502a8d': `Откройте...`,
'sda344aacb837387e': `Положение в контейнере`,
'sda5b6fa8b771f996': `Поплавок слева`,
'sda9254d1f1228e1a': `Венгерский`,
'sdb1595f5c742dfbb': `Вход`,
'sdb711380a28fec75': `Вставка списка (упорядоченного)`,
'sdb73788b3c975f16': `Авто`,
'sdbee7e0523a23a42': `Справа внизу (y)`,
'sdc48456f9a27ae02': `Генератор`,
'sdc70d81cf6c28533': `Грузинская`,
'sdd1ff479d04ac140': `Общественность`,
'sdd2fc8919a9c3111': `Режим наложения фона`,
'sdd35b688281b6dea': `Японский`,
'sddc49047f66a64ab': `Описание не предоставлено`,
'sdef34fe08bb28b09': `Китайский (упрощенный)`,
'sdf62e305e1594805': `Пометьте выделение рубиновой аннотацией`,
'sdf946172dfa0328f': `Надстрочный индекс`,
'sdf9bc5d9b7f3e3de': `Выравнивание`,
'se036b53f145441cd': `Смешанное содержание`,
'se06f459fccdc3ce9': `Выравнивание последней строки текста`,
'se0a782a8be8e018b': `Норвежский`,
'se0cda6b80a1bb50f': `Словакия`,
'se0f67eae944f8f94': `Отключить звук`,
'se1312d6528f9a259': `Йоруба`,
'se16c5e66886fbc59': `Статья`,
'se1f5bb0386c88f96': `Устанавливает цвет выделенного текста`,
'se219da7b1e955c65': `Четкое форматирование`,
'se25e4f2cb77b8be8': `Язык для интерфейса WebWriter и новые документы`,
'se2796c5824ec8916': `Наглядность контента`,
'se308836a594808b6': `Сингальцы`,
'se36c5b1baf5e0660': `В любом месте`,
'se39c065efa467782': `Баски`,
'se3b4c857f91f80d7': `Клавиатурные сокращения`,
'se47baf2fd16b9d2b': `Шаблон`,
'se48bd9e6c2a3109d': `Счета`,
'se58467472725ad0c': `Разрешение изображения`,
'se58f06c2b0583ff7': `Выберите координаты`,
'se5dc1e97fb743ade': `Расстояние между ними`,
'se619a501d1bfe6a5': `Обертывание`,
'se62385ac082368d2': `Отметьте выбор как источник цитирования`,
'se6297163cac9d276': `Редактировать источник`,
'se633223a0b88625e': `Размещение ячеек`,
'se638417c560cfe5c': `Прорваться внутрь`,
'se64f418b4e733b6c': `Вставьте выход`,
'se79c0a3ac70d8fb3': `Коэффициент амортизации (x)`,
'se79fae3ac710dc36': `Коэффициент аспирации (г)`,
'se7fad370d8fb4cec': `Оптимизируйте читаемость`,
'se8a94b4effa2033e': `Алфавитный`,
'se95d4e55ea186d9a': `Цвет полосы прокрутки`,
'se96d43a515b8451c': `Словения`,
'se96fd76ba1b2975a': `Центральный`,
'se9ac05f36b004eb0': `Скрыть ознакомительный тур. Отключите, чтобы тур был показан снова.`,
'se9b1fec72ffd8f48': `Местный`,
'sea24bdcaa2bd2dec': `Обязательная защелка`,
'sea52df2b70a5c10d': `Руби`,
'sea6e7291e27ec53f': `Переключение редактора метаданных`,
'sea896ed51ad33287': `Особые стили не предлагаются`,
'seaaaeb09e3b4e78b': `Команды редактирования`,
'seabae79729c4b2ad': `Переключить электронную почту`,
'seaecc8267bad6234': `Средняя школа`,
'seaf97719986faf4f': `Gap`,
'seb19675a580f0628': `Избегайте колонн`,
'seb4e52ef5ec7a7dc': `Цвета/эффекты`,
'seb8982ae8c3cdcc5': `Индонезия`,
'sebbced89e0db2894': `Первый базовый уровень`,
'sec02109a0dd2a6c8': `Цвет акцента`,
'sec2557a35b702525': `Переменная`,
'sec2da4aa7a02b925': `Исландия`,
'sec30fbb20f102670': `Вставить резюме`,
'sec8b0b6c729816b6': `Группа заголовков`,
'seccd05955adb76bc': `Плакат`,
'sed17285cd25d6389': `Каталог, в котором находится файл package.json`,
'sed318ec045c5144f': `Более`,
'sed713f1b916fb469': `Расстояние между границами (x)`,
'sed74a31b9172942c': `Расстояние между границами (y)`,
'sed86bd0deb2e5372': `Преобразование текста`,
'see2fcaedf9743ec6': `Расположение`,
'seec6798afe90ffc8': `Печать`,
'sef00c258bc1ecf1e': `В этом исследовании есть несохраненные изменения.`,
'sef23dd271edd4a8b': `Слева внизу`,
'sef24caccbd4645ef': `Гибкая термоусадка`,
'sef49aec68fd1dc66': `Имя`,
'sef73fe18e351eb35': `Ключевые слова`,
'sef75f458d77491af': `Опционная группа`,
'sefcf950b3cc4fc3b': `Язык`,
'sf0c8e2b013e5ff18': `Бхутани`,
'sf0ca10f343249063': `Содержание`,
'sf0cab2483f66aa2e': `Пользовательское`,
'sf0e261e04eda82ff': `Внешний вид`,
'sf1045382c1fd9a85': `Точные цвета печати`,
'sf14c35392ec7bf10': `Эта функция недоступна в Firefox. Она доступна в Chrome или Edge.`,
'sf14f9d5f9f6ca342': `К тому же легче`,
'sf1868dc19e3917bb': `Испанский`,
'sf190149f9d8bbb2a': `Режим записи`,
'sf1e79171c4856543': `Вы уверены? Это действие нельзя отменить, все ваши настройки будут удалены и
          сброшены.`,
'sf21c1f60c7515f44': `Пометьте выборку как образец вывода`,
'sf21fb4f4b9e8911f': `Ширина`,
'sf22a3737146ec910': `WebWriter может встраивать SVG непосредственно в документ.`,
'sf2514d5dc78b1654': `Вставить виджет`,
'sf28903d4ca0ddcfc': `Удалить эту учетную запись`,
'sf2ab37af0abc55ef': `Скрыть ознакомительный тур`,
'sf2bdb0b4d7b9c039': `Бенгалия`,
'sf2cbb5e519264e67': `Изменение размера по горизонтали и вертикали`,
'sf2d5cbc2fe0ad65a': `Липкий`,
'sf2d96d0eb32cb81f': `Анимационная композиция`,
'sf2de3dbe2108637a': `Визуализация формы`,
'sf2e08a945e9194d4': `Уэлч`,
'sf34696c526e810b4': `Inline`,
'sf39736a666dbb038': `Вставка дорожки`,
'sf3c4da68b08a2590': `Малагаси`,
'sf471ec2496f904cc': `Отбросьте изменения`,
'sf4849bc200e279ed': `Надпись на таблице`,
'sf486ca1fdbe08645': `Вставить рисунок`,
'sf4b537d4cbd8f5fd': `Верхняя часть текста`,
'sf4e0e02a5277ef23': `Вставка текстовой области`,
'sf4f067d41efd4b83': `Масштаб (у)`,
'sf4f3cbd41f002b46': `Масштаб (x)`,
'sf4fa67d41f05a008': `Масштаб (z)`,
'sf5197db2d5f2926a': `Повернуть`,
'sf52d840949a980d1': str`
          ${0}
          будут удалены навсегда. Вы уверены? 
        `,
'sf55d634dcc743595': `Услуги`,
'sf59c9081d106dd9c': `Пометить выделение как переменную`,
'sf5e76f774beb33c2': `Инуктитут`,
'sf64a8229a8136552': `Удалить документ`,
'sf65df67a03bebe4b': `Требуется для этого виджета`,
'sf6673729c03ae999': `Перезагрузка WebWriter`,
'sf67571992e7dc88e': `Полный срок`,
'sf6b4934598f7ed10': `Разрешить выбор`,
'sf6e1665c7022a1f8': `Пароль`,
'sf79e0d78b56444f1': `Конец линии`,
'sf7a5f7a7c80c3082': `Оба`,
'sf7c0eba7c822e3d6': `Смелый`,
'sf86bd4d2982f3b74': `Пометить выделение как код`,
'sf8e82313fa411494': `Пометить выделение как ссылку`,
'sf955eff73fb6b573': `Сербия`,
'sf9929e2d356260c5': `Умножить`,
'sf993bb199fefbe04': `Все`,
'sf9ecf969dd4b8164': `Оба края`,
'sf9f2c719a04066ec': `Приложение`,
'sfa49a5bb1a5d353e': `Частный доступ`,
'sfa59c7777e2a0eeb': `Вставка списка данных`,
'sfaa0a67db5c11f72': `Отступ первой строки текста`,
'sfb231a52211b133f': `Нет обводки текста`,
'sfb68cae41d749423': `Первоначальный`,
'sfb9b6edb0ed378c9': `Источник цитирования`,
'sfbbab09dbe553571': `Вставка векторного рисунка (SVG)`,
'sfc00292e778b67e2': `Счетчик`,
'sfc63e31ac7c956ed': `Выберите`,
'sfc815c9078bba30a': `Скачайте QR-код в виде изображения`,
'sfcdd8e672c75b713': `Адрес`,
'sfcebd18506f1e535': `Поток`,
'sfd0cde85070d2eb2': `Flex`,
'sfd77270c3f54f664': `Выход`,
'sfdb1e4d90981a535': `Поделиться этим документом`,
'sfdeef3dccf409f81': `Это ключевое слово необходимо для виджетов`,
'sfe6e758ad2603c1d': `магистратура`,
'sfee1c12daf838935': `Цветной ожог`,
'sff303daee4dd9f7b': `Лингала`,
'sff3df0c2823ec6e4': `Verso`,
'sff99962304ac7d25': `Вставить диалог`,
'sffa395f64ec6ac36': `Болгария`,
'sffdadf0a576fd802': `Высота`,
'spaceKey': `Космос`,
'tabKey': `⭾ Вкладка`,
'upKey': `↑ Вверх`,
's0dc07f97c821463c': `Comment selection`,
's780099588362f80f': `Definition item`,
's105540b7756c0232': `Definition term`,
's98b1cb8fb62909ec': `Group`,
's151349210ac1d2d8': `Insert a group`,
's2739460e44320108': `Chinese (Traditional)`,
'sdc12d4d35420eeb7': `Comments`,
's74540c1b595a229c': `TeX Formula`,
'sc221faca1ecb4aee': `Anonymous`,
's0b7ae9543c001867': `Reply`,
's52fb1524cb25d7ab': `New thread`,
'scbf29ce484222325': ``,
    };
  